import React from "react";
import { Stack, Typography } from "@mui/material";

import { DialogButton } from "../../components";

export const PartsBar = ({ disabled = false }) => {
  return (
    <Stack justifyContent="space-between" alignItems="center" direction="row">
      <Stack>
        <Typography variant="boldCaption">Parts</Typography>
        <Typography variant="caption">List of Parts</Typography>
      </Stack>
      <Stack direction="row" gap="5px">
        <DialogButton
          name="merge-customer-parts"
          label="Merge Parts"
          variant="outlined"
          color="neutral"
          size="xsmall"
          disabled={disabled}
        />
        <DialogButton
          name="create-customer-part"
          label="Create Part"
          variant="contained"
          size="xsmall"
          disabled={disabled}
        />
      </Stack>
    </Stack>
  );
};

export default PartsBar;
